import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, setUser, getUser } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUserState] = useState(getUser());
  const [cart, setCartState] = useState(() => {
    try { return JSON.parse(localStorage.getItem("optivize_cart") || "[]"); }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("optivize_cart", JSON.stringify(cart));
  }, [cart]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    setUserState(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setToken(data.token);
    setUser(data.user);
    setUserState(data.user);
    return data.user;
  };

  const logoutNow = () => {
    setToken(null);
    setUser(null);
    setUserState(null);
  };

  const addToCart = (item) => {
    setCartState((prev) => {
      const idx = prev.findIndex((x) => x.sku === item.sku);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + 1 };
        return copy;
      }
      return [...prev, { ...item, quantity: 1 }];
    });
  };

  const removeFromCart = (sku) => setCartState((prev) => prev.filter((x) => x.sku !== sku));
  const clearCart = () => setCartState([]);

  return (
    <AuthCtx.Provider value={{ user, setUser: setUserState, login, register, logout: logoutNow, cart, addToCart, removeFromCart, clearCart }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
